var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.403 94.046l-.123.098c0 4.23-.418 8.484-1.623 12.567-1.178 4.153-3.197 8.066-4.252 12.271-2.017 8.214.295 16.967 4.303 24.199-8.705-2.951-17.017-7.208-23.264-14.091-5.462-6.025-9.32-13.231-11.066-21.172-2.29-10.427-.714-20.734 3.738-30.322 2.115-4.528 4.5-8.954 6.05-13.723 1.524-4.721 2.459-9.64 3.322-14.509a50.246 50.246 0 0 1 6.886 15.665 84.8 84.8 0 0 0 16.845-50.02c16.6 9.49 28.134 25.846 31.577 44.66 4.429-5.903 5.068-13.404 4.5-20.56 1.599 1.896 3.2 3.812 4.624 5.828 11.216 15.912 17.364 36.004 13.675 55.431-1.844 9.714-6.199 18.887-12.615 26.385-6.222 7.28-14.46 12.545-23.068 16.529a83.027 83.027 0 0 0 5.186-12.545c5.632-17.632-.762-37.968-14.534-50.045 1.897 5.14 2.684 10.698 1.995 16.157-.738 5.755-3.345 11.138-5.683 16.376-1.26-6.861-2.12-13.498-6.473-19.18z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 80,
    x2: 80,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.c4e8a481cbe2add4d7f9875cc28b5edb.svg";
export { ForwardRef as ReactComponent };